var text_field_default = {
  "root": "QElUy",
  "text": "cZ9u7",
  "input": "Ymglj",
  "small": "uQmr7",
  "medium": "cTNF0",
  "large": "nCbYs",
  "webview": "_4HQSe",
  "endAdornment": "mvCvS",
  "shown": "AFZQA",
  "value": "dI06S",
  "spinner": "HQCJt",
  "spin": "i2-Pe"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
